/** How an API status code reads as a chip tone ("succeeded" → success, "overdue" → danger). */
export type ChipTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info'

const SUCCESS = new Set(['succeeded', 'paid', 'confirmed', 'active', 'published', 'approved', 'closed', 'accepted',
  'resolved', 'matched', 'sent', 'disbursed', 'completed', 'balanced'])
const WARNING = new Set(['created', 'prompt_sent', 'processing', 'pending', 'awaiting_approval', 'declared', 'due',
  'open', 'draft', 'offered', 'requested', 'unknown', 'in_progress', 'answered', 'current', 'upcoming',
  'awaiting_guarantor', 'notice', 'review', 'suspense'])
const DANGER = new Set(['declined', 'failed', 'overdue', 'expired', 'rejected', 'queried', 'cancelled', 'lapsed',
  'escalated', 'variance', 'frozen', 'deceased', 'withdrawn', 'written_off'])

export function toneFor(status: string | null | undefined): ChipTone {
  if (!status) return 'neutral'
  if (SUCCESS.has(status)) return 'success'
  if (WARNING.has(status)) return 'warning'
  if (DANGER.has(status)) return 'danger'
  return 'neutral'
}
